import { apApi, payApi } from '@/services/api/instances';

// Backward-compatible export — the AP axios instance is now owned by apApi
// (defineApi). The response interceptor is attached inside defineApi via
// attachResponseInterceptor.
export const apiClient = apApi.client;

// Payment axios instance (second client).
export const paymentApiClient = payApi.client;
